import React, { Dispatch, SetStateAction, useState } from 'react'
import { menuItemParams, socialsParams } from '../../../types'
import { ReactComponent as Logo } from '../../../assets/logo_white.svg'
import { useMediaQuery } from '../../../hooks/useMediaQuery'
import { ReactComponent as Cross } from './cross.svg'
import { motion, AnimatePresence } from 'framer-motion'
import style from './style.module.scss'
import MainNav from './MainNav'
import Externals from '../../Top/Externals'
import Menu from '../../Top/Menu'
import Socials from '../../Top/Socials'

type menuMobileProps = {
    menus: { main: menuItemParams[]; top: menuItemParams[] }
    active: boolean
    setActive: Dispatch<SetStateAction<boolean>>
    externals: {
        findClub: string
        ticketting: string
        myHand: string
        handballTV: string
        handHome: string
    }
    socials: socialsParams
}

const MenuMobile: React.FC<menuMobileProps> = ({
    menus,
    active,
    setActive,
    externals,
    socials,
}) => {
    const [activeMenu, setActiveMenu] = useState<number | null>(null)
    const tablet = useMediaQuery('(max-width: ' + style.tabletBreakpoint + ')')
    const mobile = useMediaQuery('(max-width: ' + style.mobileBreakpoint + ')')

    const { findClub, ticketting, myHand, handballTV, handHome } = externals

    if (!tablet) {
        return null
    }

    return (
        <AnimatePresence>
            {active && (
                <motion.div
                    className={style.menu}
                    initial={{
                        opacity: 0,
                    }}
                    animate={{
                        opacity: 1,
                    }}
                    transition={{
                        duration: 0.25,
                        default: { ease: 'linear' },
                    }}
                    exit={{
                        opacity: 0,
                        transition: {
                            duration: 0.1,
                        },
                    }}
                >
                    <div className={style.head}>
                        {activeMenu && (
                            <div className={style.back} onClick={() => setActiveMenu(null)}>
                                <i className="fi-rs-arrow-left" />
                            </div>
                        )}
                        <a href={'/'} className={style.logo}>
                            <Logo />
                        </a>
                        <div className={style.close} onClick={() => setActive(false)}>
                            <Cross />
                        </div>
                    </div>

                    <div className={style.container}>
                        <MainNav nav={menus.main} active={activeMenu} setActive={setActiveMenu} />

                        <motion.div
                            className={style.findClub}
                            initial={{
                                y: -50,
                                opacity: 0,
                            }}
                            animate={{
                                y: 0,
                                opacity: 1,
                            }}
                            transition={{
                                y: { stiffness: 1000, velocity: -100 },
                                delay: 0.8,
                            }}
                            exit={{
                                y: 50,
                                opacity: 0,
                                transition: {
                                    y: { stiffness: 1000 },
                                },
                            }}
                        >
                            <a href={findClub} target={'_blank'} rel={'noreferrer'}>
                                trouver un club
                            </a>
                        </motion.div>

                        {mobile && (
                            <>
                                <Externals
                                    externals={{ ticketting, myHand, handballTV, handHome }}
                                />

                                <Menu menu={menus.top} />
                                <Socials socials={socials} />
                            </>
                        )}
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    )
}

export default MenuMobile
